import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class MultiDepositLimitConfig {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	/**
	 * This config is under jurisdiction
	 */
	isDailyDepositLimitRequired(): boolean {
		return this.config.get((x) => x.commonUi.responsibleGaming.multiDepositLimit!.dailyDepositLimitRequired, true);
	}

	/**
	 * This config is under jurisdiction, if zero - then it is not set
	 */
	getDailyDepositLimitMaxValue(): number {
		return this.config.get((x) => x.commonUi.responsibleGaming.multiDepositLimit!.dailyDepositLimitMax, 0);
	}

	/**
	 * This config is under jurisdiction
	 */
	isWeeklyDepositLimitRequired(): boolean {
		return this.config.get((x) => x.commonUi.responsibleGaming.multiDepositLimit!.weeklyDepositLimitRequired, true);
	}

	/**
	 * This config is under jurisdiction, if zero - then it is not set
	 */
	getWeeklyDepositLimitMaxValue(): number {
		return this.config.get((x) => x.commonUi.responsibleGaming.multiDepositLimit!.weeklyDepositLimitMax, 0);
	}

	/**
	 * This config is under jurisdiction, if zero - then it is not set
	 */
	getMonthlyDepositLimitMaxValue(): number {
		return this.config.get((x) => x.commonUi.responsibleGaming.multiDepositLimit!.monthlyDepositLimitMax, 0);
	}

	/**
	 * This config is under jurisdiction
	 */
	isDefaultValuesEnabled(): boolean {
		return this.config.get((x) => x.commonUi.responsibleGaming.multiDepositLimit?.isDefaultValuesEnabled, false);
	}

	/**
	 * This config is under jurisdiction, if zero - then it is not set
	 */
	getDepositLimitsMaxLength(): number {
		return this.config.get((x) => x.commonUi.responsibleGaming.multiDepositLimit!.depositLimitsMaxLength, 0);
	}
}
